import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeTWPhoneTypeCreate,
  detail: routeTWPhoneTypeDetail,
  home: routePhoneTypeSettingsHome,
  root: routePhoneTypeSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-phone-type',
  createPath: 'new-phone-type',
  detailName: 'phoneTypeDetail',
  doctype: DOCTYPES.TW_PHONE_TYPE,
  homeName: 'phone-type',
  path: 'phone-type',
  views: {
    create: async () => await import('@/components/viewsExternal/twPhoneType/AddTWPhoneType.vue'),
    detail: async () => await import('@/components/viewsExternal/twPhoneType/ViewTWPhoneType.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export {
  routePhoneTypeSettingsHome,
  routePhoneTypeSettingsRoot,
  routeTWPhoneTypeCreate,
  routeTWPhoneTypeDetail,
}
